import { Component, OnInit } from '@angular/core';
import { EvaluatedcvsService } from './services/evaluatedcvs.service';
import { environment } from 'src/environments/environment';
import { ImageService } from 'src/app/services/image/image.service';

@Component({
  selector: 'app-evaluatedcvs',
  templateUrl: './evaluatedcvs.component.html',
  styleUrls: ['./evaluatedcvs.component.css'],
})
export class EvaluatedcvsComponent implements OnInit {
  constructor(
    private evaluatedcvsService: EvaluatedcvsService,
    private imageService: ImageService
  ) {}
  imagePath = environment.apiUrl;
  evaluatedCvs = [];
  selectedCv: any = null;
  ngOnInit(): void {
    this.evaluatedcvsService
      .getEvaluatedCvs()
      .subscribe((evaluatedCvs: any) => {
        this.evaluatedCvs = evaluatedCvs;
        // console.log(this.evaluatedCvs);
      });
  }
  getCvScanDetails(cv: any) {
    this.selectedCv = cv;
  }
  getImagePath(cv: any) {
    let fullImagePath = this.imageService.getImagePath(cv.cvImage);
    return this.imageService.updateImageUrl(fullImagePath);
  }
}
